export const LISTAR_INTEGRACOES = 'LISTAR_INTEGRACOES'
// export const SELECIONAR_INTEGRACOES = 'SELECIONAR_INTEGRACOES'
export const LISTAR_RAMAIS = 'LISTAR_RAMAIS'
export const LISTAR_TRONCOS = 'LISTAR_TRONCOS'
export const LISTAR_TAGS = 'LISTAR_TAGS'
export const LISTA_SEGWARE = 'LISTA_SEGWARE'
export const LISTAR_AUDIOS = 'LISTAR_AUDIOS'
export const LISTA_IA = 'LISTA_IA'
export const LISTA_OPERADOR = 'LISTA_OPERADOR'
